<div id="etollDisablingOverlay">
    <div class="overlayText">
        <div class="overlayTextHeader">{{'vehicle-details-etoll-tab.question-turn-off-etoll' | translate}}</div>
        <div class="overlayTextMain">
          {{'vehicle-details-etoll-tab.turn-off-message-part1' | translate}}
          <b class="ml-1">{{'vehicle-details-etoll-tab.turn-off-message-part2' | translate}}</b>
          <br/>
          {{'vehicle-details-etoll-tab.turn-off-message-part3' | translate}}
        </div>
        <div class="overlayButtons">
            <button class="overlayButtonAccept" (click)="dialogRef.close(true)">
              {{'vehicle-details-etoll-tab.turn-off-confirm' | translate | titlecase}}
            </button>
            <button class="overlayButtonCancel" (click)="dialogRef.close(false)">
              {{'labels.cancel' | translate | titlecase}}
            </button>
        </div>
    </div>
</div>